import http from "@/axios/http-common";
import { Textcomplete } from "@textcomplete/core";
import { TextareaEditor } from "@textcomplete/textarea";

const getObatList = function(term, callback, depoId = undefined) {
  console.log(`term from method: ${term}`);
  return http
    .getDataParam("/referensi/obat/search", {
      params: {
        term: term.trim(),
        depo: depoId
      }
    })
    .then(resp => {
      if (resp.data.length) {
        // this.textcomplete.dropdown.header = '<div>Pilih lalu tekan Enter:</div>';
        // this.textcomplete.dropdown.footer = '';
        callback(
          resp.data
            .sort((a, b) => {
              if (a.stock_qty === 0 && b.stock_qty !== 0) {
                return 1;
              } else if (a.stock_qty !== 0 && b.stock_qty === 0) {
                return -1;
              } else if (a.nama === b.nama) {
                return b.stock_qty - a.stock_qty;
              } else {
                return a.nama.localeCompare(b.nama);
              }
            })
            .map(function(obj) {
              // return obj.nama;
              return {
                nama: obj.nama,
                color: !obj.stock_qty ? "lightgrey" : "black",
                stockQty: obj.stock_qty,
                restriksi: obj.restriksi
              };
            })
        );
      } else {
        // this.textcomplete.dropdown.header = '<div class="text-center"><i class="fa fa-exclamation-circle text-danger"></i> Tak ada data, tetap ketik<br/>untuk masukkan obat:</div>';data, tetap ketik<br/>untuk masukkan obat:</div>';
        // this.textcomplete.dropdown.footer = '<div>Setelah selesai tekan Enter</div>';
        callback([term]);
      }

      return Promise.resolve(resp);
    })
    .catch(err => {
      console.log(err);

      return Promise.reject(err);
    });
};

interface ResepTextCompleteEntry {
  textcomplete: Textcomplete;
  depoId: string;
  timerId: number;
}

class ResepTextComplete {
  private entries = new Map<HTMLTextAreaElement, ResepTextCompleteEntry>();

  private buildTextcomplete(
    target: HTMLTextAreaElement,
    entry: ResepTextCompleteEntry
  ) {
    return new Textcomplete(
      new TextareaEditor(target),
      [
        {
          id: "resepText",
          match: /(^|\s)r\/([a-z0-9+\-_\s]{2,})$/i,
          search: (term: string, callback, match) => {
            clearTimeout(entry.timerId);

            entry.timerId = setTimeout(() => {
              getObatList(match[2], callback, entry.depoId);
            }, 500);
          },
          template: function(obat) {
            return `
            <div style="color: ${obat.color}">
            ${obat.nama}
            </div>
            <div style="display: flex; justify-content: space-between;">
              <div style="color: grey">stok:
               ${obat.stockQty !== null ? obat.stockQty : "n/a"}</div>
                ${
                  obat.restriksi
                    ? `<div class="customz-tooltip">
                        <svg style="margin-bottom: -5px;" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="darkorange"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.144"></g><g id="SVGRepo_iconCarrier"> <path d="M12 10V13" stroke="darkorange" stroke-width="1.6799999999999997" stroke-linecap="round"></path> <path d="M12 16V15.9888" stroke="darkorange" stroke-width="1.6799999999999997" stroke-linecap="round"></path> <path d="M10.2518 5.147L3.6508 17.0287C2.91021 18.3618 3.87415 20 5.39912 20H18.6011C20.126 20 21.09 18.3618 20.3494 17.0287L13.7484 5.147C12.9864 3.77538 11.0138 3.77538 10.2518 5.147Z" stroke="darkorange" stroke-width="1.6799999999999997" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        <span class="customz-tooltiptext">Restriksi: <br/>${obat.restriksi}</span>
                      </div>`
                    : ""
                }
            </div>
            `;
          },
          replace: function(obat) {
            return "$1R/ " + obat.nama + " No.";
          }
        }
      ],
      {
        dropdown: {
          placement: "auto",
          header: results => {
            if (results.length) {
              return "<div>Pilih obat:</div>";
            }
          },
          rotate: true
        }
      }
    );
  }

  setDepo(target: HTMLTextAreaElement, depo: string) {
    const entry = this.entries.get(target);

    if (entry) {
      entry.depoId = depo;
    }
  }

  init(target: HTMLTextAreaElement, depo: string = null) {
    if (!target) {
      return null;
    }

    this.destroy(target);

    const entry: ResepTextCompleteEntry = {
      textcomplete: null,
      depoId: depo,
      timerId: null
    };

    entry.textcomplete = this.buildTextcomplete(target, entry);

    this.entries.set(target, entry);

    return entry.textcomplete;
  }

  hide(target: HTMLTextAreaElement) {
    const entry = this.entries.get(target);

    if (entry) {
      entry.textcomplete.hide();
    }
  }

  destroy(target: HTMLTextAreaElement) {
    const entry = this.entries.get(target);

    if (!entry) {
      return;
    }

    clearTimeout(entry.timerId);
    entry.textcomplete.destroy();

    this.entries.delete(target);
  }

  on(
    target: HTMLTextAreaElement,
    eventName: "select" | "selected" | "show" | "shown",
    callBack: (evt: CustomEvent) => void
  ) {
    const entry = this.entries.get(target);

    if (entry) {
      entry.textcomplete.on(eventName, callBack);
    }
  }
}

export default new ResepTextComplete();
